import { useResponsive } from '../../../hooks/useResponsive';
import TestimonialsDesktop from './TestimonialsDesktop';
import TestimonialsMobile from './TestimonialsMobile';
import { useTestimonials } from './useTestimonials';

const Testimonials = () => {
  const breakpointIndex = useResponsive([1024]);
  const props = useTestimonials();

  if (breakpointIndex === 0) {
    return <TestimonialsMobile {...props} />;
  }
  return <TestimonialsDesktop {...props} />;
};

export default Testimonials;
